import {
  inboundCallMetric,
  officeHoursMetric,
  outboundCallsMetric,
  phonesRegisteredMetric,
  totalCallsMetric,
  voicemailGreetingsMetric,
} from '../../handoff-metrics/metrics/phones';
import { UnifyMetricDefinition, UnifyMetricEvalContext } from '../unify-metrics.types';
import { adaptHandoffMetric } from './adapt-handoff-metric';

const shouldSkipPhones = ({ officeConfigurations }: UnifyMetricEvalContext) =>
  Boolean(officeConfigurations?.isSoftwareOnly);

export const callsWorkingMetricDef: UnifyMetricDefinition = {
  id: 'calls_working',
  name: 'Calls Working',
  sectionName: 'Phones',
  allowExceptions: true,
  shouldSkip: shouldSkipPhones,
  criteria: [
    adaptHandoffMetric(inboundCallMetric),
    adaptHandoffMetric(outboundCallsMetric),
    adaptHandoffMetric(totalCallsMetric),
  ],
};

export const phonesCustomizedMetricDef: UnifyMetricDefinition = {
  id: 'phones_customized',
  name: 'Phones Customized',
  sectionName: 'Phones',
  allowExceptions: true,
  shouldSkip: shouldSkipPhones,
  criteria: [
    adaptHandoffMetric(voicemailGreetingsMetric),
    adaptHandoffMetric(officeHoursMetric),
  ],
};

export const phonesRegisteredMetricDef: UnifyMetricDefinition = {
  id: 'phones_registered',
  name: 'Phones Registered',
  sectionName: 'Phones',
  allowExceptions: true,
  shouldSkip: shouldSkipPhones,
  criteria: [adaptHandoffMetric(phonesRegisteredMetric)],
};
